  import { put, call } from "redux-saga/effects";
  import {ActionConstants, ApiConstants} from "../constants";
  import axios from "axios";

  export default function* validateStep1Saga(data) {
    try {

      const result = yield call(validateStep1Api, data.payload);

      if (result == null || result.status !== 1) {
        yield put({
          type: ActionConstants.VALIDATE_STEP_1_FAILURE,
          payload: {
            result: result != null && result.data != null ? result.data : null,
          },
        });
      } else {
        yield put({
          type: ActionConstants.VALIDATE_STEP_1_SUCCESS,
          payload: {
            result: result.data,
          },
        });
      }
    } catch (e) {
      yield put({
        type: ActionConstants.VALIDATE_STEP_1_FAILURE,
        payload: {
          result: e,
        },
      });
    }
  }

  const validateStep1Api = params => {
    const url = ApiConstants.URI_FE + ApiConstants.API_VALIDATE_STEP_1;
    return axios.post(url, params).then(response => response.data);
  };
